import React from 'react';
import { ExternalLink } from 'react-feather';
import { Link } from 'react-router-dom';
import { font_h2, font_h4, primaryFontColor } from '../Constant/constant';
import { FlexCol, FlexRow } from '../Styles';

const NotFound = () => (
    <>
        <FlexRow justify="space-evenly">
            <FlexCol basis="45%">
                <img
                    style={{ width: '100%', height: 'auto', objectFit: 'contain', filter: 'drop-shadow(2px 3px 3px black)' }}
                    src="https://mir-s3-cdn-cf.behance.net/project_modules/disp/b4e0b180881641.5cee31ace1427.gif" alt="dog zoomed by alien" />
            </FlexCol>
            <FlexCol basis="45%" style={{ textAlign: 'center', paddingTop: '70px' }}>
                <div style={{ fontSize: font_h2 }}>404 Not Found</div>
                <Link to="/" style={{ fontSize: font_h4, color: primaryFontColor }}>Go home <ExternalLink color={primaryFontColor} size={font_h4} /></Link>
            </FlexCol>
        </FlexRow>
    </>
);

export default NotFound;